<template>
  <div class="formula-builder">
    <label class="fb-label">Drag & Drop Formula Builder</label>
    
    <!-- Drop Zone for the Formula -->
    <div class="fb-drop-zone">
      <draggable 
        v-model="formula" 
        group="formula" 
        class="fb-draggable-area"
        @change="emitFormula"
      >
        <div 
          v-for="(item, index) in formula" 
          :key="'f'+index" 
          class="fb-token"
          :class="{'fb-token-operator': item.type === 'operator', 'fb-token-indicator': item.type === 'indicator'}"
        >
          {{ item.label }}
          <span class="fb-remove-token" @click="removeToken(index)">&times;</span>
        </div>
      </draggable>
      <div v-if="formula.length === 0" class="fb-placeholder">
        Tarik (drag) operator atau indikator ke area ini untuk membuat rumus.
      </div>
    </div>

    <!-- Available Items to Drag -->
    <div class="fb-palette row mt-3">
      <!-- Operators -->
      <div class="col-md-4">
        <h6 class="fb-subtitle">Operator Dasar</h6>
        <draggable 
          :list="operators" 
          :group="{ name: 'formula', pull: 'clone', put: false }"
          :clone="cloneItem"
          class="fb-source-list fb-source-operators"
        >
          <div v-for="op in operators" :key="op.value" class="fb-source-item fb-token-operator">
            {{ op.label }}
          </div>
        </draggable>
      </div>

      <!-- Indicators -->
      <div class="col-md-8">
        <h6 class="fb-subtitle">Indikator Tersedia</h6>
        <draggable 
          :list="indicators" 
          :group="{ name: 'formula', pull: 'clone', put: false }"
          :clone="cloneItem"
          class="fb-source-list fb-source-indicators"
        >
          <div v-for="ind in indicators" :key="ind.id" class="fb-source-item fb-token-indicator" :title="ind.name">
            {{ ind.name }}
          </div>
        </draggable>
      </div>
    </div>

  </div>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  name: 'FormulaBuilder',
  components: { draggable },
  props: {
    availableIndicators: {
      type: Array,
      default: () => []
    },
    value: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formula: [...this.value],
      operators: [
        { type: 'operator', value: '+', label: '+' },
        { type: 'operator', value: '-', label: '-' },
        { type: 'operator', value: '*', label: '×' },
        { type: 'operator', value: '/', label: '÷' },
        { type: 'operator', value: '(', label: '(' },
        { type: 'operator', value: ')', label: ')' },
        { type: 'number', value: '100', label: '100' }
      ]
    }
  },
  computed: {
    indicators() {
      return this.availableIndicators.map(i => ({
        type: 'indicator',
        value: i.id,
        label: i.name,
        id: i.id
      }));
    }
  },
  watch: {
    value(newVal) {
      this.formula = [...newVal];
    }
  },
  methods: {
    cloneItem(item) {
      return {
        ...item,
        id: item.id || `op_${Math.random().toString(36).substr(2, 9)}`
      };
    },
    removeToken(index) {
      this.formula.splice(index, 1);
      this.emitFormula();
    },
    emitFormula() {
      this.$emit('input', this.formula);
    }
  }
}
</script>

<style scoped>
.formula-builder {
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 15px;
  background: #fafafa;
  margin-top: 15px;
}
.fb-label {
  font-size: 13px;
  font-weight: 600;
  color: #555;
  margin-bottom: 10px;
}
.fb-drop-zone {
  min-height: 60px;
  background: #fff;
  border: 2px dashed #cbd5e1;
  border-radius: 6px;
  padding: 10px;
  position: relative;
}
.fb-draggable-area {
  min-height: 40px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
}
.fb-placeholder {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  color: #94a3b8;
  font-size: 12px;
  pointer-events: none;
}
.fb-token {
  padding: 4px 10px;
  border-radius: 14px;
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: grab;
}
.fb-token:active {
  cursor: grabbing;
}
.fb-token-operator {
  background: #e2e8f0;
  color: #334155;
  border: 1px solid #cbd5e1;
}
.fb-token-indicator {
  background: #dbeafe;
  color: #1e40af;
  border: 1px solid #bfdbfe;
}
.fb-remove-token {
  cursor: pointer;
  color: #ef4444;
  font-weight: bold;
}
.fb-subtitle {
  font-size: 11px;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 8px;
  font-weight: 600;
}
.fb-source-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}
.fb-source-item {
  padding: 4px 10px;
  border-radius: 14px;
  font-size: 11px;
  cursor: grab;
}
.fb-source-item:active {
  cursor: grabbing;
}
</style>
